// extracted by mini-css-extract-plugin
export default {"element":"Desc_element__XSry8"};